import React from 'react';

export type YuMode = 'curious' | 'fruity' | 'melancholic' | 'mysterious';

interface ModeSelectorProps {
    selectedMode: YuMode;
    onSelectMode: (mode: YuMode) => void;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({ selectedMode, onSelectMode }) => {
    const modes: YuMode[] = ['curious', 'fruity', 'melancholic', 'mysterious'];
    const basePath = import.meta.env.BASE_URL || '/';

    const labels: Record<YuMode, string> = {
        'curious': '明雨',      // Bright Rain
        'fruity': '果味雨',     // Fruity Rain
        'melancholic': '冷雨',  // Cold Rain
        'mysterious': '热雨'    // Hot Rain
    };

    return (
        <div style={{
            position: 'absolute',
            left: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            flexDirection: 'column',
            gap: '30px', // Increased gap to make room for text
            zIndex: 100, // Ensure it's above the canvas
        }}>
            {modes.map((mode) => (
                <div key={mode} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    <button
                        onClick={() => onSelectMode(mode)}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            transition: 'transform 0.2s ease',
                            transform: selectedMode === mode ? 'scale(1.1)' : 'scale(1)',
                            opacity: selectedMode === mode ? 1 : 0.6,
                        }}
                        title={mode}
                    >
                        <img
                            src={`${basePath}yus/${mode}.png`}
                            alt={mode}
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'contain',
                                filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.3))',
                            }}
                        />
                    </button>
                    <span style={{
                        color: 'white',
                        fontSize: '14px',
                        fontWeight: selectedMode === mode ? 'bold' : 'normal',
                        opacity: selectedMode === mode ? 1 : 0.7,
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                        fontFamily: '"Noto Sans SC", sans-serif' // Use a font that supports Chinese if available
                    }}>
                        {labels[mode]}
                    </span>
                </div>
            ))}
        </div>
    );
};
